<template>
  <div class="cec-index">
        <!-- <div class="kv">
            <img  src="@/assets/images/cec2022/kv.png"/>
        </div> -->
        <div class="banner-show">
            <div class="cover">
                <van-swipe :autoplay="3000" indicator-color="white" :show-indicators="false">
                    <van-swipe-item v-for="(item,key,index) in swiperImg" :key="index">
                    <img :src="item.image" alt="">
                    </van-swipe-item>
                </van-swipe>
            </div>
		</div>
        <div class="buttons">
            <div class="one">
                <img src="@/assets/images/cec2022/button1.png" @click="skip(1)"/>
            </div>
            <div class="one">
                <img src="@/assets/images/cec2022/button3.png" @click="skip(3)"/>
            </div>
            <div class="one">
                <img src="@/assets/images/cec2022/button10.png" @click="skip(10)"/>
            </div>
            <div class="one">
                <img src="@/assets/images/cec2022/button9.png" @click="skip(9)"/>
            </div>
            <div class="one" style="width: 65%;">
                <img src="@/assets/images/cec2022/button5.png" @click="skip(5)"/>
            </div>
            <div class="one">
                <img src="@/assets/images/cec2022/button6.png" @click="skip(6)"/>
            </div >
            <div class="one">
                <img src="@/assets/images/cec2022/button13.png" @click="skip(13)"/>
            </div>
            <div class="one">
                <img src="@/assets/images/cec2022/button7.png" @click="skip(7)"/>
            </div>
            <div class="one">
                <img src="@/assets/images/cec2022/button12.png" @click="skip(12)"/>
            </div>
            <div class="one">
                <img src="@/assets/images/cec2022/button11.png" @click="skip(11)"/>
            </div>
            <div class="one">
                <img src="@/assets/images/cec2022/button8.png" @click="skip(8)"/>
            </div>
        </div>
        <img  src="@/assets/images/cec2022/index_bottom.png" style="width:100%;display:block;"/>
    </div>
</template>

<script>
import {MeetingsDetails,MeetingsCarousel} from '../../config/interface.js'
export default {
    data(){
        return{
            swiperImg:[]
        }
    },
    created(){
        document.title="CEC血管论坛2022";
        this.getMeetingDetails();
        this.getMeetingCarousel();
    },
    methods:{
        skip(type){
            switch(type){
                case 1:
                    this.$router.push('/cec2022/info?button_id=806');
                    break;
                case 2:
                    this.$router.push('/cec2022/organizor?button_id=807');
                    break;
                case 3:
                    this.$router.push('/cec2022/schedule?id=286&button_id=808')
                    break;
                case 4:
                    this.$router.push('/column/details?id=97&button_id=934')
                    break;
                case 5:
                    // this.$router.push('/cec2022/coming?meeting_id=286&button_id=809')
                    this.$router.push('/vascularNews/meeting/live?meeting_id=286&button_id=809')
                    break;
                case 6:
                    this.$router.push('/vascularNews/exhibition?meeting_id=286')
                    break;
                case 7:
                    window.location.href='http://bbh5.imjiayi.com/'
                    break;
                case 8:
                    this.$router.push('/cec2022/contact?button_id=812');
                    break;
                case 9:
                    this.$router.push('/vascularNews/personal/taskbookDetail?meeting_id=286&button_id=811')
                    break;
                case 10:
                    this.$router.push('/vascularnews/expert/search?meeting_id=286&button_id=810')
                    break;
                case 11:
                    this.$router.push('/cec2022/download');
                    break;
                case 12:
                    this.$router.push('/cec2022/personal');
                    break;
                case 13:
                    window.location.href='https://e720.net/vr/MmU0NWE3MDItNGIwMS02OTYwLTkwODQtNWM1NWRmYzA3ODM3.html'
                    break;
                
            }
        },
        //会议详情
        getMeetingDetails(){
            const url=MeetingsDetails;
            const method='POST';
            let params={
                meeting_id:286
            }
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    // document.title=data.name;
                    //微信浏览器  请求jsdk
                    if(common.is_weixin()){
                        common.wxShare(data.name,data.title,data.shareimg);
                    }
                }
            })
        },
        //会议轮播
        getMeetingCarousel(){
            const url=MeetingsCarousel;
            let params={
                meeting_id:286
            }
            const method='POST';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    this.swiperImg=data;
                }
            })
        },
    }
}
</script>

<style scoped lang="scss">
.cec-index{
    background-image: url('../../assets/images/cec2022/bird_2.png');
    background-size: 110% auto;
    background-repeat: no-repeat;
    background-position-y: 9rem;
}
.cec-index .kv img{
	width: 100%;
}
.cec-index .buttons{
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	margin: 10px 5% 0;
}
.cec-index .buttons .one{
	width: 30%;
	margin: 10px 0;
}
.cec-index .buttons img{
    width: 100%;
}
.banner-show{
    width:100%;
    .cover{
        width:100%;
        // margin-bottom:14px;
        img{
            width:100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/cec2022/index.vue